import React from 'react';

import { SpinnerContainer, StyledSpinnerIcon } from './Spinner.styles';

export type Props = React.PropsWithChildren<{
  /**
   * Set true to show loader
   */
  show: boolean;
  /**
   * Color variant of spinner, LIGHT for dark background, DARK for light background
   */
  variant?: 'LIGHT' | 'DARK';
  /**
   * Occupy full width of parent element
   */
  fullHeight?: boolean;
  /**
   * CSS class, mostly to make wrapping by styled-component possible
   */
  className?: string;
}>;

/**
 * Render loading spinner when performing async operations
 */
const Spinner: React.FC<Props> = ({
  show,
  variant = 'DARK',
  fullHeight = false,
  children,
  className,
}) => {
  return (
    <SpinnerContainer fullHeight={fullHeight} className={className}>
      {show && <StyledSpinnerIcon variant={variant} />}
      {children}
    </SpinnerContainer>
  );
};

export default Spinner;
